import { errorTicketPrefill } from '@supply/contracts'
import * as React from 'react'

import { onErrorReportRequest } from '@/lib/error-capture'
import { SupportTicketDialog, type SupportPrefill } from '@/modules/support/SupportTicketDialog'

/**
 * "Reportar" do toast de erro em segundo plano: abre o chamado
 * pré-preenchido sem tirar a pessoa da tela. Montado dentro da sessão, para o
 * nome vir do SSO.
 */
export function ErrorReportHost() {
  const [prefill, setPrefill] = React.useState<SupportPrefill | null>(null)

  React.useEffect(() => onErrorReportRequest((ctx) => setPrefill(errorTicketPrefill(ctx))), [])

  return <SupportTicketDialog open={prefill !== null} onOpenChange={(open) => !open && setPrefill(null)} prefill={prefill ?? undefined} />
}
